import { IDiv } from 'types/components/components.interface';
import './TableRowItemAddButtonsWrapper.scss';

interface ITableRowItemAddButtonsProps extends IDiv {}

const TableRowItemAddButtonsWrapper = ({
  children,
  className = '',
  ...props
}: ITableRowItemAddButtonsProps) => {
  return (
    <div {...props} className={`add-button-wrapper ${className}`}>
      {children}
    </div>
  );
};

export default TableRowItemAddButtonsWrapper;
